import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TZimuinKyuyoDownloadCsvPostReq,
  TZimuinSyuroZikanListGetReq,
  TZimuinSyuroZikanListGetRes,
  TZimuinSyuroZikanPutReq,
} from "./TZimuinSyuroZikan"

/**
 * 事務員就労時間に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class ZimuinSyuroZikanService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TZimuinSyuroZikanListGetReq} params
   * @memberof ZimuinSyuroZikanService
   */
  getList = async (
    params: TZimuinSyuroZikanListGetReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<TZimuinSyuroZikanListGetRes[]>> =
        await this.getInner(
          `/driverpayroll/zimuinsyurozikan/list`,
          params,
          signal
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 給与実績 単体取得
   *
   * @param {TZimuinSyuroZikanListGetReq} params
   * @memberof ZimuinSyuroZikanService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TZimuinSyuroZikanListGetRes>> =
        await this.getInner(
          `/driverpayroll/zimuinsyurozikan/register/${id}`,
          signal
        )
      return res.data

      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * 給与実績更新(リスト登録更新)
   *
   * @param {TZimuinSyuroZikanPutReq} data
   * @memberof ZimuinSyuroZikanService
   */
  putList = async (data: TZimuinSyuroZikanPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driverpayroll/zimuinsyurozikan/register`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 給与実績更新（単体）
   *
   * @param {TZimuinSyuroZikanPutReq} data
   * @memberof ZimuinSyuroZikanService
   */
  put = async (data: TZimuinSyuroZikanPutReq, id: number | string) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driverpayroll/zimuinsyurozikan/register/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 給与実績登録（単体）
   *
   * @param {TZimuinSyuroZikanPutReq} data
   * @memberof ZimuinSyuroZikanService
   */
  post = async (data: TZimuinSyuroZikanPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/driverpayroll/zimuinsyurozikan/register`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * CSVダウンロード処理
   *
   * @param {TZimuinKyuyoDownloadCsvPostReq} params
   * @memberof ZimuinSyuroZikanService
   */
  downloadCsv = async (params: TZimuinKyuyoDownloadCsvPostReq) => {
    try {
      const res: AxiosResponse<Blob> = await this.postInner(
        `/driverpayroll/zimuinsyurozikan/actions/downloadcsv`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
